import querystring from "query-string";
import axiosInstance, { errorHandler } from "./api";
import { imageEncode } from "../util/imageEncoder";
import { dateFormatter } from "@/util/formatter";

const VERIFICATION_URL = "/tps/api/verification-requests";

// VerificationRequestResource.getAllMobileVerificationRequests
const getVerificationRequestsMobile = axios => (
  page,
  size,
  filter = "",
  sort = "",
) =>
  axios
    .get(
      `${VERIFICATION_URL}/mobile?${querystring.stringify({
        page,
        size,
        filter,
        sort,
      })}`,
    )
    .then(({ data, headers }) => ({
      data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);

// VerificationRequestResource.getAllDesktopVerificationRequests
const getVerificationRequestsDesktop = axios => (
  page,
  size,
  filter = "",
  sort = "",
) =>
  axios
    .get(
      `${VERIFICATION_URL}/desktop?${querystring.stringify({
        page,
        size,
        filter,
        sort,
      })}`,
    )
    .then(({ data, headers }) => ({
      data,
      total: Number(headers["x-total-count"]),
    }))
    .catch(errorHandler);

// VerificationRequestResource.updateVerificationRequest
const getVerificationRequest = axios => id =>
  axios
    .get(`${VERIFICATION_URL}/${id}`)
    .then(({ data }) => data)
    .catch(errorHandler);

const getActiveVerificationRequest = axios => accountId =>
  axios
    .get(`${VERIFICATION_URL}/get-active-for-account/${accountId}`)
    .then(({ data }) => data)
    .catch(errorHandler);

// VerificationRequestResource.approveVerificationRequest
const approveVerificationRequest = axios => ({ verificationId, limitId }) =>
  axios
    .put(`${VERIFICATION_URL}/approve`, { verificationId, limitId })
    .then(() => {})
    .catch(errorHandler);

// VerificationRequestResource.rejectVerificationRequest
const rejectVerificationRequest = axios => verificationId =>
  axios
    .put(`${VERIFICATION_URL}/reject`, { verificationId })
    .then(() => {})
    .catch(errorHandler);

const getDocumentsPhoto = axios => (identityUuid = "") =>
  axios
    .get(`/authservice/api/v1/user/identity?uuid=${identityUuid}`, {
      headers: {
        Accept: "image/*",
      },
      responseType: "arraybuffer",
    })
    .then(res => imageEncode(res.data, res.headers["content-type"]))
    .catch(errorHandler);

const getUserPhoto = axios => (photoUuid = "") =>
  axios
    .get(`/authservice/api/v1/user/photo?uuid=${photoUuid}`, {
      headers: {
        Accept: "image/*",
      },
      responseType: "arraybuffer",
    })
    .then(res => imageEncode(res.data, res.headers["content-type"]))
    .catch(errorHandler);

/**
 * Fetches a list of updates of user's account
 */
const getUserHistoryByAccountId = axios => (accountId = "") =>
  axios
    .get(`/authservice/api/v1/user/edit-profile/history/${accountId}`)
    .then(({ data }) =>
      data.map(r => ({ ...r, dateTime: dateFormatter(r.dateTime) })),
    )
    .catch(errorHandler);

/**
 * Update user account
 */
const updateUserAccount = axios => form =>
  axios
    .post("/authservice/api/v1/user/edit-profile", form)
    .then(({ data }) => data)
    .catch(errorHandler);

const getUserIdentityHistory = axios => accountId =>
  axios
    .get(`/authservice/api/v1/user/edit-profile/identity/history/${accountId}`)
    .then(({ data }) =>
      data.map(r => ({
        ...r,
        dateTime: dateFormatter(r.dateTime),
        live: String(r.live),
        faceMatch: String(r.faceMatch),
      })),
    )
    .catch(errorHandler);

export default {
  getVerificationRequest: getVerificationRequest(axiosInstance),
  approveVerificationRequest: approveVerificationRequest(axiosInstance),
  rejectVerificationRequest: rejectVerificationRequest(axiosInstance),
  getActiveVerificationRequest: getActiveVerificationRequest(axiosInstance),
  getDocumentsPhoto: getDocumentsPhoto(axiosInstance),
  getUserPhoto: getUserPhoto(axiosInstance),
  getVerificationRequestsMobile: getVerificationRequestsMobile(axiosInstance),
  getVerificationRequestsDesktop: getVerificationRequestsDesktop(axiosInstance),
  getUserHistoryByAccountId: getUserHistoryByAccountId(axiosInstance),
  updateUserAccount: updateUserAccount(axiosInstance),
  getUserIdentityHistory: getUserIdentityHistory(axiosInstance),
};
